
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M11.5 21H7a2 2 0 01-2-2v-6a2 2 0 012-2h10a2 2 0 012 2"}}),_c('path',{attrs:{"d":"M11 16a1 1 0 102 0 1 1 0 00-2 0m-3-5V7a4 4 0 118 0v4m4 10l2-2-2-2m-3 0l-2 2 2 2"}})])])
          )
        }
      }
    